import { CommonData } from "../datastructures/gamestate/gameData";
import { setCookie } from "./cookies";
export function autoSelectMusic(activeGameData: CommonData) {
  musicSelect(activeGameData.bonusGameMode ? 1 : 0, activeGameData);
  // if (activeGameData.bonusGameMode) {
  //     musicSelect(1, activeGameData);
  // }

  // else {

  //     musicSelect(0, activeGameData)
  // }

  // console.log(activeGameData.bonusGameMode,'BONUS GAME')
}

export function musicSelect(index: number, activeGameData: CommonData) {
  if (index === 1) {
    // && activeGameData.music.playing()) {
    activeGameData.normalGameMusic.stop();
    if (activeGameData.bonusGameMusic.playing() === false) {
      activeGameData.bonusGameMusic.play("bonus");
      // console.log('play bonus game music')
    }
  }
  if (index == 0) {
    //&& activeGameData.music2.playing()) {
    activeGameData.bonusGameMusic.stop();
    if (activeGameData.normalGameMusic.playing() === false) {
      activeGameData.normalGameMusic.play("music");
      // console.log('play base game music')
    }
  }
}

export function toggleBonusMusicOption(activeGameData: CommonData) {
  if (activeGameData.bonusGameMusic.mute() == false) {
    muteMusic2(activeGameData, true);
    setCookie("bonusMusic", true, 365);
  } else {
    autoSelectMusic(activeGameData);
    muteMusic2(activeGameData, false);
    setCookie("bonusMusic", false, 365);
  }
}

export function muteMusic2(activeGameData: CommonData, bool: boolean) {
  if (bool) {
    activeGameData.gameOption.setBonusMusicOn(false); //bonusMusicToggleSwitch.turnOn(false);
    for (let i = 0; i < activeGameData.bonusMusicList.length; i++) {
      activeGameData.bonusMusicList[i].mute(true);
    }
  } else {
    activeGameData.gameOption.setBonusMusicOn(true); //bonusMusicToggleSwitch.turnOn(true);
    for (let i = 0; i < activeGameData.bonusMusicList.length; i++) {
      activeGameData.bonusMusicList[i].mute(false);
    }
  }

  // console.log(playMusic)
}

export function toggleMuteOption(activeGameData: CommonData) {
  console.log("music playing", activeGameData.normalGameMusic.playing());
  if (activeGameData.normalGameMusic.mute() == false) {
    muteMusic(activeGameData, true);
    setCookie("music", true, 365);
    console.log(" mute base game music");

    if (activeGameData.normalGameMusicList[0].mute() === false) {
      //extra check because for some reason on browser it doenst  alswys mute on first mute request;
      //   console.log("is muted",activeGameData.normalGameMusicList[0].mute(),"muter harder ! ");//
      muteMusic(activeGameData, true);
      setCookie("music", true, 365);
    }
    // console.log("muter harder worked:  ! ",activeGameData.normalGameMusicList[0].mute())
  } else {
    // autoSelectMusic(activeGameData);
    muteMusic(activeGameData, false);
    setCookie("music", false, 365);
    console.log(" unmute base game music");
  }
}

export function toggleTurboMode(activeGameData: CommonData) {
  activeGameData.turboEnabled = !activeGameData.turboEnabled;
  activeGameData.gameOption.setTurboOn(activeGameData.turboEnabled); //soundsliderButton.turnOn(false)
}

export function muteMusic(activeGameData: CommonData, bool: boolean) {
  if (bool) {
    //
    activeGameData.gameOption.setBgMusicOn(false); //bgMusicToggleSwitch.turnOn(false)
    // console.log("music set as false")
    for (let i = 0; i < activeGameData.normalGameMusicList.length; i++) {
      // activeGameData.normalGameMusicList[i].volume(0);
      activeGameData.normalGameMusicList[i].mute(true);
    }
  } else {
    // activeGameData.music.volume(.25);
    // activeGameData.music2.volume(1);
    activeGameData.gameOption.setBgMusicOn(true); //bgMusicToggleSwitch.turnOn(true)
    //    console.log("music set as true")

    for (let i = 0; i < activeGameData.normalGameMusicList.length; i++) {
      // activeGameData.normalGameMusicList[i].volume(1);
      activeGameData.normalGameMusicList[i].mute(false);
    }
  }
}

export function changeSoundVolume(activeGameData: CommonData) {
  if (activeGameData.sound.mute() == false) {
    muteSound(activeGameData, true);
    setCookie("sound", true, 365);
  } else {
    muteSound(activeGameData, false);
    setCookie("sound", false, 365);
  }
}

export function muteSound(activeGameData: CommonData, bool: boolean) {
  if (activeGameData.gameOption != undefined) {
    if (bool) {
      activeGameData.gameOption.setSoundOn(false); //soundsliderButton.turnOn(false)

      for (let i = 0; i < activeGameData.soundList.length; i++) {
        activeGameData.soundList[i].mute(true);
      }
    } else {
      activeGameData.gameOption.setSoundOn(true); //soundsliderButton.turnOn(true);
      for (let i = 0; i < activeGameData.soundList.length; i++) {
        activeGameData.soundList[i].mute(false);
      }
    }
  } else {
    console.log("activeGameData.gameOption doesn;t exist");
  }
}
export function disableFHD(activeGameData: CommonData, bool: boolean) {
  if (activeGameData.isTableGame == false) {
    if (bool) {
      activeGameData.gameResolution = [1280, 720];
      if (activeGameData.isMobile) {
        activeGameData.gameResolution = [854, 480];
      }
      activeGameData.gameOption.setHDOn(false); // fullHDSliderButton.turnOn(false);
    } else {
      activeGameData.gameResolution = [1920, 1080]; //desktop max resolution
      if (activeGameData.isMobile) {
        activeGameData.gameResolution = [854, 480];
      }
      activeGameData.gameOption.setHDOn(true); //fullHDSliderButton.turnOn(true);
    }
  } else {
    activeGameData.gameResolution = [1920, 1080];
    activeGameData.gameOption.setHDOn(true);
  }

  activeGameData.gameResize();
}

export function setDynamicRenderResolution(activeGameData: CommonData) {
  let hdSwitchOn = activeGameData.gameOption.getHDIsOn();
  // let gameRes=activeGameData.gameResolution;
  let isPortrait = activeGameData.isInPortraitMode;
  // console.log(isPortrait)
  if (isPortrait && activeGameData.isMobile) {
    if (hdSwitchOn) {
      // activeGameData.gameResolution = [1280, 720];//720p
      // activeGameData.gameResolution = [720, 405];//720p
      activeGameData.gameResolution = [854, 480];
    } else {
      // activeGameData.gameResolution = [720, 405];//405pvertical gameheight (not whole screen height)
      activeGameData.gameResolution = [1280, 720]; //
    }

    if (activeGameData.isTableGame) {
      //for roulette
      // activeGameData.gameResolution = [1920, 1080];
      activeGameData.gameResolution = [1280, 720]; //
    }
  } else {
    if (hdSwitchOn) {
      activeGameData.gameResolution = [1920, 1080]; //desktop max resolution
      if (activeGameData.isMobile) {
        activeGameData.gameResolution = [1280, 720];
      }

      // console.log('reset to 1920',);
      // activeGameData.gameResize();
    } else {
      activeGameData.gameResolution = [1280, 720]; //desktop max resolution
      if (activeGameData.isMobile) {
        activeGameData.gameResolution = [960, 540];
      }
    }

    if (activeGameData.isTableGame) {
      //for roulette
      activeGameData.gameResolution = [1920, 1080];
    }
  }
  // console.log('set res to',activeGameData.gameResolution );
}
export async function toggleFullScreenOption(activeGameData: CommonData) {
  if (!activeGameData) {
    console.error("activeGameData is undefined!");
    return;
  }
  // Check if Fullscreen API is supported by the browser
  if (
    !document.documentElement.requestFullscreen &&
    !document.documentElement.webkitRequestFullscreen &&
    !document.documentElement.mozRequestFullScreen &&
    !document.documentElement.msRequestFullscreen
  ) {
    console.warn("Fullscreen mode is not supported.");
    return;
  }

  const isWebView = (() => {
    const userAgent = navigator.userAgent;

    // Check for Android WebView (Lollipop+)
    const isAndroidWebView =
      /wv/.test(userAgent) ||
      /Version\/[\d.]+.*Chrome\/[\d.]+ Mobile Safari\/[\d.]+/.test(userAgent);

    // Check for iOS WebView (WebKit without Safari)
    const isiOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      userAgent
    );

    // Fallback: Check for WebKit with no Chrome (generic WebView detection)
    const hasWebKitButNotChrome =
      window.hasOwnProperty("webkit") && !window.hasOwnProperty("chrome");

    return isAndroidWebView || isiOSWebView || hasWebKitButNotChrome;
  })();

  if (isWebView) {
    console.warn("Fullscreen does not work in WebView environments.");
    return;
  }

  // If already in fullscreen mode, exit fullscreen
  if (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  ) {
    try {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        await document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        await document.msExitFullscreen();
      }
      activeGameData.gameOption.setFullScreenOn(false);
    } catch (error) {
      console.error("An error occurred while exiting fullscreen mode:", error);
    }
  } else {
    // Request fullscreen mode
    try {
      const element = document.documentElement; // You can use any element you want to go fullscreen (e.g., body)
      if (element.requestFullscreen) {
        await element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen();
      }
      if (activeGameData?.gameOption?.setFullScreenOn) {
        activeGameData.gameOption.setFullScreenOn(true);
      }
    } catch (error) {
      console.error(
        "An error occurred while requesting fullscreen mode:",
        error
      );
    }
  }
}

export function disable60Fps(activeGameData: CommonData, bool: boolean) {
  if (bool) {
    // console.log("set to 24 fps")
    activeGameData.renderFrameRate.startAnimating(45);
    activeGameData.gameFPS = activeGameData.minFPS;
    activeGameData.gameOption.setFpsOn(false); //fullFpsSlierButton.turnOn(false);
  } else {
    // console.log("set to 60 fps")
    activeGameData.renderFrameRate.startAnimating(60);
    activeGameData.gameFPS = activeGameData.maxFPS;
    activeGameData.gameOption.setFpsOn(true); //fullFpsSlierButton.turnOn(true)
  }
}
export function toggleFullHD(activeGameData: CommonData) {
  if (activeGameData.gameOption.getHDIsOn()) {
    disableFHD(activeGameData, true);
    setCookie("fullhd", true, 365);
  } else {
    disableFHD(activeGameData, false);
    setCookie("fullhd", false, 365);
  }
}
export function toggle60Fps(activeGameData: CommonData) {
  if (activeGameData.gameOption.getFPSIsOn()) {
    // activeGameData.gameFPS=60;
    disable60Fps(activeGameData, true);
    setCookie("fpslimit", true, 365);
  } else {
    // activeGameData.gameFPS=30;
    disable60Fps(activeGameData, false);
    setCookie("fpslimit", false, 365);
  }
}

// export function muteMusic2(activeGameData: CommonData, bool: boolean) {
//     if (bool) {
//         activeGameData.gameOption.setBonusMusicOn(false);//bonusMusicToggleSwitch.turnOn(false);
//         for (let i = 0; i < activeGameData.bonusMusicList.length; i++) {
//             activeGameData.bonusMusicList[i].volume(0);
//         }
//     }

//     else {

//         activeGameData.gameOption.setBonusMusicOn(true);//bonusMusicToggleSwitch.turnOn(true);
//         for (let i = 0; i < activeGameData.bonusMusicList.length; i++) {
//             activeGameData.bonusMusicList[i].volume(1);

//         }
//     }
// }
